export default __webpack_public_path__ + "static/media/Duskfang.26f82137.jpg";